import { useEffect } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppWrap } from "../wrapper/index";

import {
  CollegeForm,
  CourseForm,
  StudentForm,
  ProposalForm,
  ProposalFormEditing,
  CollegesMain,
  CoursesMain,
  StudentsMain,
  ProposalMain,
  NotFound,
  CreatorHome,
  StudentProfile,
} from "../components";

import { authenticathingUser } from "../actions/auth";

const CreatorMain = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authenticathingUser());

    //eslint-disable-next-line
  }, []);

  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route
          path={`${path}/colleges/section-college/:id`}
          component={CollegeForm}
        />
        <Route
          path={`${path}/colleges/section-college`}
          component={CollegeForm}
        />
        <Route
          path={`${path}/courses/section-course/:id`}
          component={CourseForm}
        />
        <Route path={`${path}/courses/section-course`} component={CourseForm} />
        <Route
          path={`${path}/students/section-student/profile/:id`}
          component={StudentProfile}
        />
        <Route
          path={`${path}/students/section-student/:id`}
          component={StudentForm}
        />
        <Route
          path={`${path}/students/section-student`}
          component={StudentForm}
        />
        <Route
          path={`${path}/proposals/section-proposal/:id`}
          component={ProposalFormEditing}
        />
        <Route
          path={`${path}/proposals/section-proposal`}
          component={ProposalForm}
        />
        <Route path={`${path}/colleges`} component={CollegesMain} />
        <Route path={`${path}/courses`} component={CoursesMain} />
        <Route path={`${path}/students`} component={StudentsMain} />
        <Route path={`${path}/proposals`} component={ProposalMain} />
        <Route path={`${path}/*`} component={NotFound} />
        <Route path={`${path}`} component={CreatorHome} />
      </Switch>
    </>
  );
};

export default AppWrap(CreatorMain);
